// @ts-check
import { LBButton } from '@linearb/buzz';
import { WhiteSection } from 'components/base/layout-components';
import { StyledSelectedCategory } from './SelectedCategory.style';
import { StyledWidgetHeader } from '../CategoriesWidget.style';
import useIssuesDisplay from './useIssuesDisplay';
import IssuesList from './IssuesList';
import Icon from 'components/base/Icon';
import CategoryStats from './CategoryStats';
import SelectedCategoryLoader from './SelectedCategoryLoader';

const SelectedCategory = ({ selectedCategory, categories, isLoading }) => {
  const { shouldDisplayIssues, toggleIssuesDisplay } = useIssuesDisplay({
    selectedCategory
  });

  if (isLoading) return <SelectedCategoryLoader />;
  if (!selectedCategory) return null;

  return (
    <StyledSelectedCategory>
      <WhiteSection>
        <StyledWidgetHeader>
          {selectedCategory?.name}
          {shouldDisplayIssues && (
            <div className='ml-auto'>
              <LBButton
                variant='ghost'
                size='icon'
                onClick={toggleIssuesDisplay}
              >
                <Icon name='close' />
              </LBButton>
            </div>
          )}
        </StyledWidgetHeader>
        {shouldDisplayIssues ? (
          <IssuesList selectedCategory={selectedCategory} />
        ) : (
          <CategoryStats
            selectedCategory={selectedCategory}
            categories={categories}
            toggleIssuesDisplay={toggleIssuesDisplay}
          />
        )}
      </WhiteSection>
    </StyledSelectedCategory>
  );
};

export default SelectedCategory;
